var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useState } from 'react';
import { Box, Flex, Input, Button, IconButton, getPaletteColor, Card } from 'pcln-design-system';
import styled from 'styled-components';
import MicIcon from '../svgs/MicIcon';
import broadcast, { BroadcastType, usePennySubscriber } from '../utils/pennyBroadcast';
import StopCircleIcon from '../svgs/StopCircleIcon';
var UserInputContainer = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding: 0 8px;\n  align-items: center;\n  background-color: ", ";\n  justify-content: space-between;\n"], ["\n  ", "\n  padding: 0 8px;\n  align-items: center;\n  background-color: ", ";\n  justify-content: space-between;\n"])), function (props) {
    if (props.isRecording) {
        return "\n        height: 67px;\n        margin: 0px;\n        border-top: 1px solid ".concat(getPaletteColor('border.tint')(props), ";\n        border-radius: 0;\n      ");
    }
    else {
        return "\n        height: 67px;\n        margin: 1px;\n        border-radius: 0 0 24px 24px;\n      ";
    }
}, function (props) { return getPaletteColor('background.lightest')(props); });
var MicContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 44px;\n  width: 44px;\n"], ["\n  height: 44px;\n  width: 44px;\n"])));
var StyledInput = styled(Input)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 24px;\n  border-style: none;\n"], ["\n  border-radius: 24px;\n  border-style: none;\n"])));
var UserInputBar = function (props) {
    var _a = useState(''), textInput = _a[0], setTextInput = _a[1];
    var _b = useState(false), isRecording = _b[0], setIsRecording = _b[1];
    var _c = useState(false), isAudioPlaying = _c[0], setIsAudioPlaying = _c[1];
    var pennyBroadcastListener = useCallback(function (event) {
        if (event.data.type === BroadcastType.USER_IS_SILENT) {
            props.onStopRecording();
        }
        else if (event.data.type === BroadcastType.VOICE_RECORDING_STARTED) {
            setIsRecording(true);
        }
        else if (event.data.type === BroadcastType.VOICE_RECORDING_STOPPED) {
            setIsRecording(false);
        }
        else if (event.data.type === BroadcastType.AUDIO_PLAYBACK_STARTED) {
            setIsAudioPlaying(true);
        }
        else if (event.data.type === BroadcastType.AUDIO_QUEUE_DRAINED) {
            setIsAudioPlaying(false);
        }
    }, [props.onStopRecording]);
    usePennySubscriber(pennyBroadcastListener);
    var handleTextChange = function (e) {
        setTextInput(e.target.value);
    };
    var handleTextSubmit = function () {
        setTextInput('');
        if (props.onTextSubmit) {
            props.onTextSubmit(textInput);
        }
    };
    var handleEnterKeyPress = function (e) {
        if (e.key === 'Enter') {
            handleTextSubmit();
        }
    };
    var handleRecordButtonClick = function (e) {
        if (props.onRecord) {
            props.onRecord();
        }
    };
    var haltPlayback = function () {
        broadcast({ type: BroadcastType.INTERRUPT_AUDIO_PLAYBACK, sender: 'UserInputBar' });
    };
    return (React.createElement(UserInputContainer, { isRecording: isRecording },
        React.createElement(Card, { mr: 2, width: '100%', borderRadius: 24, boxShadowSize: 'sm' },
            React.createElement(StyledInput, { id: 'chatInput', "data-testid": 'chatInput', autoComplete: 'off', onChange: handleTextChange, value: textInput, placeholder: 'Ask Penny a question', onKeyPress: handleEnterKeyPress, mr: 2 })),
        textInput && (React.createElement(Button, { onClick: handleTextSubmit, mr: 2 }, "Submit")),
        React.createElement(MicContainer, null, isRecording ? (React.createElement(IconButton, { onClick: props.onStopRecording, icon: React.createElement(StopCircleIcon, null) })) : isAudioPlaying ? (React.createElement(IconButton, { onClick: haltPlayback, icon: React.createElement(StopCircleIcon, null) })) : (React.createElement(IconButton, { onClick: handleRecordButtonClick, icon: React.createElement(MicIcon, null) })))));
};
export default UserInputBar;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=UserInputBar.js.map